export const isMobile = () => {
	// return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	return /Mobi|Android/i.test(navigator.userAgent);
}


// /Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent)